export * from './post-erforderliches-dokument.component';
export * from './post-erforderliches-dokument.component.module';